export const LinksStrings = {
  termsOfService: (lang = 'en') => `https://www.logmein.com/${lang}/legal/terms-and-conditions`,
  privacyPolicy: (lang = 'en') => `https://www.logmein.com/${lang}/legal/privacy`,
  goToWebinarPrivacyPolicy: 'https://www.goto.com/company/legal/privacy/us',
  customerSupport: (lang = 'en') => {
    if (lang === 'en') {
      return `https://support.goto.com/webinar`;
    }
    return `https://support.goto.com/${lang}/webinar`;
  },
};
